export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6982.d0b13ebe.jpg";